/* byos-collection.js: count-up, price filter and tile entrance for the BYOS collection page. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var grid = document.querySelector('[data-bc-grid]');
    var tiles = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-bc-tile]')) : [];

    var num = document.querySelector('[data-bc-count]');
    if (num && !reduced) {
      var to = parseInt(num.getAttribute('data-bc-count'), 10) || 0, t0 = null;
      num.textContent = '0';
      setTimeout(function () {
        (function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / 1400);
          num.textContent = String(Math.round(to * (1 - Math.pow(1 - p, 3))));
          if (p < 1) requestAnimationFrame(step);
        })(performance.now());
      }, 500);
    }

    if (!grid) return;

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting && e.boundingClientRect.top > 0) return;
          e.target.classList.add('is-in'); io.unobserve(e.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -4% 0px' });
      tiles.forEach(function (t) { io.observe(t); });
    } else {
      tiles.forEach(function (t) { t.classList.add('is-in'); });
    }

    // Category chips filter in place. The grid holds every component; each tile lists its collections.
    var shown = grid.querySelector('[data-bc-shown]');
    var chips = Array.prototype.slice.call(grid.querySelectorAll('[data-bc-cat]'));
    function apply(cat, push, href) {
      var n = 0;
      chips.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-bc-cat') === cat); });
      tiles.forEach(function (t) {
        var cats = (t.getAttribute('data-cats') || '').split(' ');
        var ok = cat === 'all' || cats.indexOf(cat) > -1;
        t.hidden = !ok;
        if (ok) { n++; t.classList.remove('is-in'); void t.offsetWidth; t.style.setProperty('--n', n - 1); requestAnimationFrame(function () { t.classList.add('is-in'); }); }
      });
      if (shown) shown.textContent = String(n);
      if (push && href && window.history && history.pushState) history.pushState({ bc: cat }, '', href);
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        apply(chip.getAttribute('data-bc-cat'), true, chip.getAttribute('href'));
      });
    });
    window.addEventListener('popstate', function () {
      var m = chips.filter(function (c) { return c.pathname === location.pathname; })[0];
      apply(m ? m.getAttribute('data-bc-cat') : 'all', false);
    });
    var initial = chips.filter(function (c) { return c.classList.contains('is-on'); })[0];
    if (initial) { var cat0 = initial.getAttribute('data-bc-cat'); if (cat0 !== 'all') apply(cat0, false); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
